/** Normaliseer zaalnamen voor vergelijking (dom_event locatie ↔ Google agenda). */
export function normalizeRoomName(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/\s+/g, " ")
    .replace(/\./g, "")
    .replace(/2e\s*verd\.?/g, "2e verd")
    .replace(/vergaderzaal/g, "vergaderzaal");
}

export function roomsMatch(locationName: string | null, googleRoomName: string | null): boolean {
  if (!locationName || !googleRoomName) return false;
  const a = normalizeRoomName(locationName);
  const b = normalizeRoomName(googleRoomName);
  if (a === b) return true;
  if (a.includes(b) || b.includes(a)) return true;
  return false;
}
